import { useCallback, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApplicationStore } from '@data';

const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const events = [
  'focus',
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart',
];

type Props = {
  children: React.ReactNode;
};

export default function InactivityTimeout({ children }: Props): JSX.Element {
  const clearSessionData = useApplicationStore(
    (state) => state.clearSessionData,
  );
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      clearSessionData();
      navigate('/services');
    }, INACTIVITY_TIMEOUT);
  }, [clearSessionData, navigate]);

  useLayoutEffect(() => {
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer]);

  return <>{children}</>;
}
